"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const shallow_1 = require("zustand/shallow");
const UserContext_1 = require("context/UserContext");
const useAdjustWeightModal_1 = require("hooks/useAdjustWeightModal/useAdjustWeightModal");
const HelperUtils_1 = require("utils/HelperUtils");
const SVGIcon_1 = __importDefault(require("components/shared/SVGIcon"));
const TooltipContainer_1 = __importDefault(require("components/shared/Tooltips/TooltipContainer"));
const Header = () => {
    const { config: { includeTeamGoals, permissions: { objectiveWeightManage } } } = (0, UserContext_1.useUser)();
    const { isPercentage, isComplexity } = (0, useAdjustWeightModal_1.useAdjustWeightModalStore)((state) => ({
        isPercentage: state.isPercentage,
        isComplexity: state.isComplexity
    }), shallow_1.shallow);
    return (react_1.default.createElement("div", { className: "flex items-center h-[16px] mb-[16px]" },
        react_1.default.createElement("div", { className: "w-full typography-h100 text-n-800 min-w-[376px] mr-[24px]" }, (0, HelperUtils_1.getObjectiveLocale)('My Goals')),
        react_1.default.createElement("div", { className: `w-full typography-h100 text-n-800 min-w-[200px] mr-[24px] ${isPercentage ? 'order-2' : ''}` }, (!isPercentage && !isComplexity) || includeTeamGoals
            ? (0, HelperUtils_1.getObjectiveLocale)('Type')
            : isComplexity && (0, HelperUtils_1.getObjectiveLocale)('Complexity')),
        !isComplexity && objectiveWeightManage && (react_1.default.createElement("div", { className: `w-full typography-h100 text-n-800 min-w-[124px] ${isPercentage ? 'order-1' : ''}` },
            react_1.default.createElement("div", { className: "flex" },
                react_1.default.createElement("p", { className: "typography-h100 text-n-800 width-auto whitespace-nowrap" }, `${(0, HelperUtils_1.getObjectiveLocale)('Weight')} (%)`),
                react_1.default.createElement(TooltipContainer_1.default, { show: true, text: (0, HelperUtils_1.getObjectiveLocale)('Add options not to use weight'), useMaxWidth: false, classContainer: "ml-[8px]" },
                    react_1.default.createElement(SVGIcon_1.default, { iconName: "icon-info", size: 16, fillColor: "var(--n-500)" })))))));
};
exports.default = Header;
